import { Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Dr. M. Halloran",
    role: "Functional Med ∙ USA",
    text: "After three weeks I observed measurable changes in inflammation markers and recovery in patients using X39. The data speaks for itself.",
    color: "#00F0FF",
  },
  {
    name: "Sara K.",
    role: "Athlete ∙ Berlin",
    text: "Deep sleep tripled the first week. I recover from training sessions in half the time. It's the simplest tool I've added to my stack.",
    color: "#D900FF",
  },
  {
    name: "Daniel R.",
    role: "Distributor ∙ Singapore",
    text: "I've never sold a product that customers re-order so consistently. The story is wild but the results land — every single time.",
    color: "#00FF66",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-5">
            <span className="text-label">∙ 04 / Voices</span>
            <h2 className="mt-4 font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Real cells.
              <br />
              <span className="text-[#00F0FF] glow-cyan">Real results.</span>
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="glass-card p-8 flex flex-col gap-6 relative"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <Quote
                className="w-8 h-8 opacity-60"
                style={{ color: r.color }}
                strokeWidth={1.5}
              />
              <p className="text-white/85 leading-relaxed text-sm">
                "{r.text}"
              </p>
              <div className="mt-auto pt-4 border-t border-white/10">
                <div className="font-display font-bold text-base">{r.name}</div>
                <div className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-white/40 mt-1">
                  {r.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
